/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Void_Dialog_TitleInputs */



/**
* | output |
* | --- |
* | "Void commission entries?" |
*
* @param {Partner_Admin_Commission_Void_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_void_dialog_title = /** @type {((inputs?: Partner_Admin_Commission_Void_Dialog_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Void_Dialog_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Provisionseinträge stornieren?")
	return /** @type {LocalizedString} */ ("Void commission entries?")
});